import React from 'react';
import UserLogin from '../Components/UserLogin';

export default function Login() {
  return (
    <div>
      <UserLogin />
    </div>
  )
}
